import React, { FC } from 'react';

import FormGroup from '../FormGroup';

import { $InputGroup } from './InputGroup.styles';

interface InputGroupProps {
  withoutPaddingBottom?: boolean;
  withoutPaddingTop?: boolean;
  className?: string;
}

const InputGroup: FC<React.PropsWithChildren<InputGroupProps>> = ({
  children,
  withoutPaddingBottom,
  withoutPaddingTop,
  className,
}) => {
  return (
    <FormGroup
      withoutPaddingBottom={withoutPaddingBottom}
      withoutPaddingTop={withoutPaddingTop}
    >
      <$InputGroup className={className}>{children}</$InputGroup>
    </FormGroup>
  );
};

export default InputGroup;
